import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import Home from './Home';
import CreateMember from './Create_member';
import PrivacyPolicy from './PrivacyPolicy';
import Support from './Support';
import { LanguageProvider } from './LanguageContext';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <LanguageProvider>
      <Toaster position="top-center" reverseOrder={false} />
      <BrowserRouter>
        {/* Header removed - navigate to / or /admin directly in the browser */}
        <main>
          <Routes>
            <Route path="/" element={<AdminLogin />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/create" element={<CreateMember />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </main>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;


